// courseDomain.js — sursă unică (frontend) pentru diferențierea vizuală pe domeniu:
// SSM = albastru (primary), SU = roșu (danger). Folosit la creare (CourseContent) și
// la parcurgere (TestPage etc.) ca badge + tentă foarte ușoară pe card.

/**
 * Returnează clasele Tailwind + etichetele pentru domeniul unui curs, dedus din `type`
 * (orice tip care se termină în `_SU` e SU; restul SSM).
 */
export const getCourseDomainStyle = (type = '') => {
  const isSU = String(type).endsWith('_SU');
  return {
    isSU,
    domain: isSU ? 'SU' : 'SSM',
    label: isSU ? 'Situații de Urgență (SU)' : 'Securitate și Sănătate în Muncă (SSM)',
    // Badge mic lângă titlu
    badgeClass: isSU
      ? 'bg-danger-100 text-danger-700 dark:bg-danger-950/40 dark:text-danger-300'
      : 'bg-primary-100 text-primary-700 dark:bg-primary-950/40 dark:text-primary-300',
    // Tentă blândă dar vizibilă pe card + bordură colorată (odihnitor pentru ochi, dar se vede)
    cardTint: isSU
      ? 'bg-danger-100 dark:bg-danger-950/30 border border-danger-300 dark:border-danger-900/50'
      : 'bg-primary-100 dark:bg-primary-950/30 border border-primary-300 dark:border-primary-900/50',
  };
};
